"use client";

import { DateSegment } from "./date-segment";
import { useRef } from "react";
import {
  AriaTimeFieldProps,
  TimeValue,
  useLocale,
  useTimeField,
} from "react-aria";
import { useTimeFieldState } from "react-stately";
import { cn } from "@/lib/utils";
import { FORM_CONTROL_CLASS_NAME } from "@/components/Forms/form-control-styles";

function TimeField(
  props: AriaTimeFieldProps<TimeValue> & { className?: string },
) {
  const ref = useRef<HTMLDivElement | null>(null);

  const { locale } = useLocale();
  const state = useTimeFieldState({
    ...props,
    locale,
  });
  const {
    fieldProps: { ...fieldProps },
    labelProps: _labelProps,
  } = useTimeField(props, state, ref);

  return (
    <div
      {...fieldProps}
      ref={ref}
      className={cn(
        "inline-flex w-full flex-1 items-center border focus-within:border-primary focus-within:ring-2 focus-within:ring-primary/15 focus-within:ring-offset-0",
        FORM_CONTROL_CLASS_NAME,
        props.isDisabled && "cursor-not-allowed border-slate-200 bg-slate-50",
        props.className,
      )}
    >
      {state.segments.map((segment, i) => (
        <DateSegment
          aria-label={props.label || "Time"}
          key={i}
          segment={segment}
          state={state}
        />
      ))}
    </div>
  );
}

export { TimeField };
